import { bindEvent } from 'vtils'

export function onPageVisibilityChange(
  cb: (visible: boolean) => any,
): () => void {
  return bindEvent(document)(
    'visibilitychange',
    e => {
      if (e && e.detail && e.detail.source === 'dcb') return
      cb(!!document.visibilityState && document.visibilityState === 'visible')
    },
    { passive: true },
  )
}
